// extracted by mini-css-extract-plugin
export default {"online-scheduling":"SYDzP9","online-scheduling__content":"ukjKUd","online-scheduling__body":"Uvg4qH","online-scheduling__iframe":"wRtDSU"};